import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import { toast } from 'react-toastify'

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle,
    //------------- globalStates
    globalStates,
    //------------- defalutData
    defaultData, 
    //------------- Helpers
    Helpers,
    //------------- Forms
    Forms,
    //------------- FetchData
    FetchData
}) =>{

    // Para redirigir a otras pantallas
    const navigate = useNavigate();

    // ------------------------------------ DEMO MODAL
    const abrirModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }
    
    const cerrarModal = () => {
        toggle()
    }

    const handleClickDemoModal = async (_, title, compont, dataRequest) => {
        abrirModal(_, title, compont, dataRequest)
    }

    // ------------------------------------ DEMO MODAL

    const handleClickShowForm = (flag) => {
        const { setShowForm } = globalStates
        setShowForm(flag)
    }

    // Cancela la visualizacion del formulario al darle click al botón "Cancelar"
    const handleClickHideForm = () => {

        const { setFormOpeningMode } = globalStates
        const { FormScreen } = Forms
        const { onResetForm } = FormScreen

        onResetForm()
        handleClickShowForm(false)
        setFormOpeningMode('EDITABLE')

    }

    const handleClickFetchAllManagements = async () => {

        const { fetchAllManagements } = FetchData
        const { executeFetch } = fetchAllManagements

        executeFetch()

    }

    const handleClickFetchSpecificManagement = async (idmanagement, formOpeningMode) => {
        
        const { setFormOpeningMode } = globalStates
        
        const { FormScreen } = Forms
        const { onResetForm } = FormScreen

        const { fetchSpecificManagement, fetchInfoProcessLawyer } = FetchData
        const { setParamsToSearch, executeFetch } = fetchSpecificManagement

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({
            idmanagement: idmanagement,
            fecthLawyerInfo: {
                flag: true,
                refFetchDataFunction: fetchInfoProcessLawyer
            }
        })
        executeFetch()

        handleClickShowForm(true)
        setFormOpeningMode(formOpeningMode)

    }

    const handleClickDeleteManagement = async (idmanagement) => {

        Swal.fire({
            title: '¿Está seguro de eliminar este registro?',
            text: 'Esta acción no se puede deshacer, haga click en "Eliminar" para continuar',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Eliminar',
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/lawyer-managements/delete-management/${idmanagement}`)
                .then(({ data }) => {
                    
                    alertMessage(data)
                    handleClickFetchAllManagements()

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
        
    }

    const handleClickSearchProcessLawyer = async () => {
        
        const { FormScreen } = Forms
        const { formState } = FormScreen

        const { fetchInfoProcessLawyer } = FetchData

        if(formState.process_number === ''){
            alertMessage({
                flag: 'FAIL',
                message: 'No ha escrito el identificador de recepción de vehículo',
                rows: []
            })
            return
        }

        fetchInfoProcessLawyer.setParamsToSearch({
            process_number: formState.process_number
        })
        fetchInfoProcessLawyer.executeFetch()

    }
    
    const onSubmitForm = async (e) => {

        e.preventDefault()

        const { setLoadingSubmitForm } = globalStates
        const { FormScreen } = Forms
        const { formState, onResetForm } = FormScreen

        if(formState.infoProcessLawyer.length === 0) {
            alertMessage({
                flag: 'FAIL',
                message: `No se han encontrado resultados para el identificador: ${formState.process_number}`
            })
            return
        }

        const _dataBody = {
            idmanagement: formState.idmanagement,
            idmanagementtypes: formState.idmanagementtypes,
            process_number: formState.process_number,
            idlawyer: formState.infoProcessLawyer[0].idlawyer,
            gestion_fecha: formState.gestion_fecha,
            gestion_usuario: user.username,
            gestion_descripcion: formState.gestion_descripcion,
            info_descuento: formState.info_descuento,
            aprobacion_check: 'Pendiente Aprobacion',
            aprobacion_usuario: user.username,
            aprobacion_fecha: formState.gestion_fecha,
            aprobacion_observaciones: '-',
            user: user.username
        }

        // console.log('[useActions][onSubmitForm] _dataBody ', _dataBody)
        setLoadingSubmitForm(true)
        if(_dataBody.idmanagement > 0){

            await marvarApi.put( `/lawyer-managements/update-management/${_dataBody.idmanagement}`, _dataBody )
                .then(({ data }) => {

                    alertMessage(data)
                    onResetForm()
                    handleClickFetchAllManagements()
                    handleClickHideForm()
                    setLoadingSubmitForm(false)

                })
                .catch(error => {
                    setLoadingSubmitForm(false)
                    console.log('API ERROR: ', error)
                })

        }else{

            await marvarApi.post( `/lawyer-managements/create-management`, _dataBody )
                .then(({ data }) => {
                    
                    alertMessage(data)
                    onResetForm()
                    handleClickFetchAllManagements()
                    handleClickHideForm()
                    setLoadingSubmitForm(false)

                })
                .catch(error => {
                    setLoadingSubmitForm(false)
                    console.log('API ERROR: ', error)
                })

        }
    }

    return Object.freeze({
        abrirModal,
        cerrarModal,
        handleClickDemoModal,
        
        handleClickShowForm,
        handleClickHideForm,
        handleClickFetchAllManagements,
        handleClickFetchSpecificManagement,
        handleClickDeleteManagement,
        handleClickSearchProcessLawyer,
        onSubmitForm
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {

    if (res) {
        const { flag, message } = res
        if (flag === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}